export default __webpack_public_path__ + "loader_icon.png";